module.exports = __webpack_public_path__ + "static/media/mango.4f9f15d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/mango.jpg
// module id = 130
// module chunks = 0